export default "__VITE_ASSET__DsZxwR9n__"